  <!-- Edit Widget Dropdown -->
          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="editTrigger"
            [cdkConnectedOverlayOpen]="activeDropdownIndex === index" [cdkConnectedOverlayOffsetY]="10"
            (overlayOutsideClick)="toggleSizeDropdown(index, $event)">
            <div class="edit-widget-dropdown" (click)="$event.stopPropagation()">
              <div class="edit-section">
                <div class="header-item">
                  <img class="icon-small" src="assets/icons/img_pencil.svg" />
                  <div class="label">Edit Widget</div>
                </div>
                <div class="separator"></div>

                <ng-container *ngFor="let sizeOption of getAvailableSizes(index)">
                  <div class="size-item" (click)="changeWidgetSize(index, sizeOption.value)">
                    <div class="icon-box">
                      <div class="size-icon" [ngClass]="{
                        'small': sizeOption.value === 'small',
                        'medium': sizeOption.value === 'medium',
                        'large': sizeOption.value === 'half',
                        'xlarge': sizeOption.value === 'full'
                      }">
                        <ng-container [ngSwitch]="sizeOption.value">
                          <!-- Small: 4 rectangles -->
                          <ng-container *ngSwitchCase="'small'">
                            <div class="rect"></div>
                            <div class="rect"></div>
                            <div class="rect"></div>
                            <div class="rect"></div>
                          </ng-container>
                          <!-- Medium: 2 rectangles -->
                          <ng-container *ngSwitchCase="'medium'">
                            <div class="rect"></div>
                            <div class="rect"></div>
                          </ng-container>
                          <!-- Half/Large: 1 rectangle -->
                          <ng-container *ngSwitchCase="'half'">
                            <div class="rect"></div>
                          </ng-container>
                          <!-- Full/XLarge: 1 rectangle -->
                          <ng-container *ngSwitchCase="'full'">
                            <div class="rect"></div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                    <div class="label">{{ sizeOption.label }}</div>
                  </div>
                </ng-container>

                <div class="separator"></div>
                <div class="size-item delete-item" (click)="removeWidget(index)">
                  <div class="icon-box">
                    <img class="icon-small" src="assets/icons/img_trash.svg" />
                  </div>
                  <div class="label delete-label">Delete Widget</div>
                </div>
              </div>

              <div class="help-section" *ngIf="introWorkFlage">
                <img class="icon-help" src="assets/icons/img_help-polygon.svg" />
                <div class="help-text">How does this work?</div>
              </div>
            </div>
          </ng-template>